import { defineMessages } from 'react-intl';
import addAndRemoveObjectsFromArray from '../../../helpers/addAndRemoveObjectsFromArray';
import Default from './Default';
import TextInner from './TextInner';
import TextLateral from './TextLateral';

defineMessages({
  textBelow: {
    id: 'Text Below',
    defaultMessage: 'Text Below',
  },
  textLateral: {
    id: 'Text Lateral',
    defaultMessage: 'Text Lateral',
  },
  textInner: {
    id: 'Text Inner',
    defaultMessage: 'Text Inner',
  },
});

const removedDefaultVariations = ['default'];

const teaserVariations = [
  {
    id: 'Text Below',
    isDefault: true,
    title: 'Text Below',
    template: Default,
  },
  {
    id: 'Text Lateral',
    isDefault: false,
    title: 'Text Lateral',
    template: TextLateral,
  },
  {
    id: 'Text Inner',
    isDefault: false,
    title: 'Text Inner',
    template: TextInner,
  },
];

const applyConfig = (config) => {
  config.blocks.blocksConfig.teaser.variations = addAndRemoveObjectsFromArray(
    config.blocks.blocksConfig.teaser.variations,
    teaserVariations,
    removedDefaultVariations,
  );

  return config;
};

export default applyConfig;
